import { TransformGroupResult } from 'api/ordering-service/ordering-service.types';
import { useGroupsToolbar, useGroupsDataGrid } from '../groups-landing.hooks';
import GroupsDetailsDrawer from '../../groups-details-drawer/groups-details-drawer.component';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import GroupDeleteDrawer from '../../group-delete-drawer/group-delete-drawer.component';
import GroupsDeleteDrawer from '../../groups-delete-drawer/groups-delete-drawer.component';
import MenuManagementBulkEditDataGrid from 'pages/menu-management/menu-management-bulk-edit-data-grid/menu-management-bulk-edit-data-grid.component';

type GroupsDataGridProps = {
  isImported?: boolean;
};

const GroupsDataGrid = ({ isImported = false }: GroupsDataGridProps) => {
  const groupsDetailsDrawer = useUtilityDrawer<TransformGroupResult>();
  const deleteConfirmationDrawer = useUtilityDrawer<TransformGroupResult>();
  const bulkDeleteConfirmationDrawer = useUtilityDrawer<TransformGroupResult>();
  const columns = useGroupsDataGrid(isImported, deleteConfirmationDrawer);
  const { toolbar, initialState } = useGroupsToolbar(
    bulkDeleteConfirmationDrawer,
  );

  return (
    <>
      <MenuManagementBulkEditDataGrid
        columns={columns}
        toolbar={toolbar}
        initialState={initialState}
        data-testid={
          isImported ? 'GroupsImportedDataGrid' : 'GroupsNativeDataGrid'
        }
        onRowClick={params => {
          groupsDetailsDrawer.setDrawerData(params?.row);
          groupsDetailsDrawer.setOpen(true);
        }}
        getRowId={(row: TransformGroupResult) => row?.groupId}
      />
      <GroupsDetailsDrawer {...groupsDetailsDrawer} />
      <GroupDeleteDrawer {...deleteConfirmationDrawer} />
      <GroupsDeleteDrawer
        open={bulkDeleteConfirmationDrawer.open}
        close={bulkDeleteConfirmationDrawer.close}
      />
    </>
  );
};

export default GroupsDataGrid;
